import {GET_ACCOUNT, SET_ACCOUNT} from "@/core/store/modules/account/constants";
import api from "@/core/services/api/api.service";

export default {
    [GET_ACCOUNT](context) {
        if (context.getters.isAuthenticated) {
            return new Promise((resolve, reject) => {
                api.get('/panel').then(response => {
                    context.commit(SET_ACCOUNT, response.data.company);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })

            })
        }
    }
}